import * as moment from 'moment';
import {Moment} from 'moment';
import {RegionFeatures} from './region-features.model';
import {BufferDurations} from './buffer-durations.model';
import {RegionTmsSyncSchedulerTime} from './region-tmssync-scheduletime.model';
import {DistanceUnit} from '../../shared/distance-unit';
import {Country} from './country.model';
import { CMBLLangCode } from '../../core/languages';

export class Region {

  public id: string;
  public name: string;
  public failedPickupContactEmails: string[] = [];
  public hotspotAlertsContactEmails: string[] = [];
  public reRouteErrorContactEmails: string[] = [];
  public contactEmails: string[] = [];
  public countries: Country[] = [];
  public createdAt: Moment;
  public updatedAt: Moment;
  public features: RegionFeatures;
  public bufferDurations: BufferDurations;
  public tmsSyncWindows: RegionTmsSyncSchedulerTime[] = [RegionTmsSyncSchedulerTime.UTC_02];
  public distanceUnit                                 = DistanceUnit.KILOMETERS;
  public preferredTimezone: string;
  public preferredLanguage: CMBLLangCode;
  public minutesSpentInHotspotArea = 0;

  static withDefaultBufferDurations(): Region {
    const bufferDurations = new BufferDurations();
    bufferDurations.setDefaultValue();

    return new Region(new RegionFeatures(), bufferDurations);
  }

  static fromDto(d: any): Region {
    if (!d) {
      return null;
    }

    const region = new Region();

    region.id                = d.id;
    region.name              = d.name;
    region.contactEmails     = d.contact_emails;
    region.countries         = d.countries ? d.countries.map(country => Country.fromDto(country)) : [];
    region.createdAt         = d.created_at ? moment(d.created_at) : null;
    region.updatedAt         = d.updated_at ? moment(d.updated_at) : null;
    region.features          = RegionFeatures.fromDto(d.features);
    region.bufferDurations   = BufferDurations.fromDto(d.buffer_durations);
    region.tmsSyncWindows    = d.tms_sync_windows;
    region.distanceUnit      = d.distance_unit;
    region.preferredTimezone = d.preferred_timezone;
    region.preferredLanguage = d.preferred_language_code;
    region.failedPickupContactEmails     = d.failed_pickup_contact_emails;
    region.hotspotAlertsContactEmails    = d.hotspot_alerts_contact_emails;
    region.reRouteErrorContactEmails     = d.re_route_error_contact_emails;
    region.minutesSpentInHotspotArea     = d.minutes_spent_in_hotspot_area;

    return region;
  }

  static toDto(r: Region): any {
    if (!r) {
      return null;
    }

    return {
      id: r.id,
      name: r.name,
      countries: r.countries.map(country => Country.toDto(country)),
      contact_emails: r.contactEmails,
      created_at: null,
      updated_at: null,
      features: RegionFeatures.toDto(r.features),
      buffer_durations: BufferDurations.toDto(r.bufferDurations),
      tms_sync_windows: r.tmsSyncWindows,
      distance_unit: r.distanceUnit,
      preferred_timezone: r.preferredTimezone,
      preferred_language_code: r.preferredLanguage,
      failed_pickup_contact_emails: r.failedPickupContactEmails,
      hotspot_alerts_contact_emails: r.hotspotAlertsContactEmails,
      re_route_error_contact_emails: r.reRouteErrorContactEmails,
      minutes_spent_in_hotspot_area: r.minutesSpentInHotspotArea,
    };
  }

  constructor(features?: RegionFeatures, bufferDurations?: BufferDurations) {
    this.features        = features;
    this.bufferDurations = bufferDurations;
  }
}
